// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_utils_common = require("./Expln_utils_common.res.js");

var ex = {
  begin: {
    x: 0,
    y: 0
  },
  end: {
    x: 1,
    y: 0
  }
};

var ey = {
  begin: {
    x: 0,
    y: 0
  },
  end: {
    x: 0,
    y: 1
  }
};

function deg(d) {
  return d / 180 * Math.PI;
}

function rad(r) {
  return r;
}

function toDeg(a) {
  return a / Math.PI * 180;
}

function toRad(a) {
  return a;
}

function pntX(p) {
  return p.x;
}

function pntY(p) {
  return p.y;
}

function pntLen(p) {
  return Math.sqrt(p.x * p.x + p.y * p.y);
}

function pntSub(a, b) {
  return {
          x: a.x - b.x,
          y: a.y - b.y
        };
}

function pntAdd(a, b) {
  return {
          x: a.x + b.x,
          y: a.y + b.y
        };
}

function pntTrDelta(p, dx, dy) {
  return {
          x: p.x + dx,
          y: p.y + dy
        };
}

function pntTr(p, v) {
  return pntTrDelta(p, v.end.x - v.begin.x, v.end.y - v.begin.y);
}

function pntMul(p, x) {
  return {
          x: p.x * x,
          y: p.y * x
        };
}

function pntDiv(p, x) {
  return {
          x: p.x / x,
          y: p.y / x
        };
}

function pntVec(b, e) {
  return {
          begin: b,
          end: e
        };
}

function pntRot(p, a) {
  return {
          x: p.x * Math.cos(a) - p.y * Math.sin(a),
          y: p.x * Math.sin(a) + p.y * Math.cos(a)
        };
}

function vecBegin(v) {
  return v.begin;
}

function vecEnd(v) {
  return v.end;
}

function vecLen(v) {
  return pntLen(pntSub(v.end, v.begin));
}

function vecMul(v, x) {
  return {
          begin: v.begin,
          end: pntAdd(pntMul(pntSub(v.end, v.begin), x), v.begin)
        };
}

function vecMulVec(v1, v2) {
  var a = pntSub(v1.end, v1.begin);
  var b = pntSub(v2.end, v2.begin);
  return a.x * b.x + a.y * b.y;
}

function vecDiv(v, x) {
  return {
          begin: v.begin,
          end: pntAdd(pntDiv(pntSub(v.end, v.begin), x), v.begin)
        };
}

function vecAdd(a, b) {
  return {
          begin: a.begin,
          end: pntAdd(a.end, pntSub(b.end, b.begin))
        };
}

function vecRot(v, a) {
  return {
          begin: v.begin,
          end: pntAdd(pntRot(pntSub(v.end, v.begin), a), v.begin)
        };
}

function vecNorm(v) {
  return vecDiv(v, vecLen(v));
}

function vecSwapEnds(v) {
  return {
          begin: v.end,
          end: v.begin
        };
}

function vecBeginAt(v, p) {
  return {
          begin: p,
          end: pntTr(p, v)
        };
}

function vecEndAt(v, p) {
  return vecSwapEnds(vecBeginAt(vecSwapEnds(v), p));
}

function vecTr(v, t) {
  var dx = t.end.x - t.begin.x;
  var dy = t.end.y - t.begin.y;
  return {
          begin: pntTrDelta(v.begin, dx, dy),
          end: pntTrDelta(v.end, dx, dy)
        };
}

function vecTrDir(v, dir, dist) {
  return vecTr(v, vecMul(vecNorm(dir), dist));
}

function pntTrDir(p, dir, dist) {
  return pntTr(p, vecMul(vecNorm(dir), dist));
}

function vecRev(v) {
  return vecRot(v, Math.PI);
}

function bndMinX(b) {
  return b.minX;
}

function bndMinY(b) {
  return b.minY;
}

function bndMaxX(b) {
  return b.maxX;
}

function bndMaxY(b) {
  return b.maxY;
}

function bndIncludes(b, p) {
  if (b.minX <= p.x && p.x < b.maxX && b.minY <= p.y) {
    return p.y < b.maxY;
  } else {
    return false;
  }
}

function bndWidth(b) {
  return b.maxX - b.minX;
}

function bndHeight(b) {
  return b.maxY - b.minY;
}

function bndFromPoints(ps) {
  if (ps.length === 0) {
    Expln_utils_common.exn("Cannot create boundaries from an empty array of points.");
  }
  var minX = ps[0].x;
  var minY = ps[0].y;
  var maxX = minX;
  var maxY = minY;
  for(var i = 1 ,i_finish = ps.length; i < i_finish; ++i){
    var p = ps[i];
    minX = Math.min(minX, p.x);
    minY = Math.min(minY, p.y);
    maxX = Math.max(maxX, p.x);
    maxY = Math.max(maxY, p.y);
  }
  return {
          minX: minX,
          minY: minY,
          maxX: maxX,
          maxY: maxY
        };
}

function bndFromVectors(vs) {
  if (vs.length === 0) {
    Expln_utils_common.exn("Cannot create boundaries from an empty array of vectors.");
  }
  var p1 = vs[0].begin;
  var p2 = vs[0].end;
  var minX = Math.min(p1.x, p2.x);
  var minY = Math.min(p1.y, p2.y);
  var maxX = Math.max(p1.x, p2.x);
  var maxY = Math.max(p1.y, p2.y);
  for(var i = 1 ,i_finish = vs.length; i < i_finish; ++i){
    var p1$1 = vs[i].begin;
    var p2$1 = vs[i].end;
    minX = Math.min(minX, Math.min(p1$1.x, p2$1.x));
    minY = Math.min(minY, Math.min(p1$1.y, p2$1.y));
    maxX = Math.max(maxX, Math.max(p1$1.x, p2$1.x));
    maxY = Math.max(maxY, Math.max(p1$1.y, p2$1.y));
  }
  return {
          minX: minX,
          minY: minY,
          maxX: maxX,
          maxY: maxY
        };
}

function bndAddPoint(b, p) {
  return {
          minX: Math.min(b.minX, p.x),
          minY: Math.min(b.minY, p.y),
          maxX: Math.max(b.maxX, p.x),
          maxY: Math.max(b.maxY, p.y)
        };
}

function bndMerge(b1, b2) {
  return {
          minX: Math.min(b1.minX, b2.minX),
          minY: Math.min(b1.minY, b2.minY),
          maxX: Math.max(b1.maxX, b2.maxX),
          maxY: Math.max(b1.maxY, b2.maxY)
        };
}

function bndAddPoints(b, ps) {
  if (ps.length === 0) {
    return b;
  } else {
    return bndMerge(b, bndFromPoints(ps));
  }
}

function bndLeftBottom(b) {
  return {
          x: b.minX,
          y: b.minY
        };
}

function bndLeftTop(b) {
  return {
          x: b.minX,
          y: b.maxY
        };
}

function bndRightBottom(b) {
  return {
          x: b.maxX,
          y: b.minY
        };
}

function bndRightTop(b) {
  return {
          x: b.maxX,
          y: b.maxY
        };
}

function bndAddMargin(b, all, left, right, top, bottom) {
  if (all !== undefined) {
    return {
            minX: b.minX - all,
            minY: b.minY - all,
            maxX: b.maxX + all,
            maxY: b.maxY + all
          };
  } else {
    return {
            minX: b.minX - Belt_Option.getWithDefault(left, 0),
            minY: b.minY - Belt_Option.getWithDefault(bottom, 0),
            maxX: b.maxX + Belt_Option.getWithDefault(right, 0),
            maxY: b.maxY + Belt_Option.getWithDefault(top, 0)
          };
  }
}

function bndAddMarginPct(b, all, left, right, top, bottom) {
  if (all !== undefined) {
    var size = Math.max(bndWidth(b), bndHeight(b));
    var margin = size * all;
    return {
            minX: b.minX - margin,
            minY: b.minY - margin,
            maxX: b.maxX + margin,
            maxY: b.maxY + margin
          };
  }
  var w = bndWidth(b);
  var h = bndHeight(b);
  return {
          minX: b.minX - w * Belt_Option.getWithDefault(left, 0),
          minY: b.minY - h * Belt_Option.getWithDefault(bottom, 0),
          maxX: b.maxX + w * Belt_Option.getWithDefault(right, 0),
          maxY: b.maxY + h * Belt_Option.getWithDefault(top, 0)
        };
}

function bndMergeAll(bs) {
  if (bs.length === 0) {
    return Expln_utils_common.exn("Cannot merge empty array of boundaries.");
  }
  var b = bs[0];
  for(var i = 1 ,i_finish = bs.length; i < i_finish; ++i){
    b = bndMerge(b, bs[i]);
  }
  return b;
}

var Std2D = {
  ex: ex,
  ey: ey,
  deg: deg,
  rad: rad,
  toDeg: toDeg,
  toRad: toRad,
  pntX: pntX,
  pntY: pntY,
  pntLen: pntLen,
  pntSub: pntSub,
  pntAdd: pntAdd,
  pntTr: pntTr,
  pntTrDir: pntTrDir,
  pntMul: pntMul,
  pntDiv: pntDiv,
  pntVec: pntVec,
  pntRot: pntRot,
  vecBegin: vecBegin,
  vecEnd: vecEnd,
  vecLen: vecLen,
  vecRev: vecRev,
  vecMul: vecMul,
  vecMulVec: vecMulVec,
  vecDiv: vecDiv,
  vecAdd: vecAdd,
  vecRot: vecRot,
  vecNorm: vecNorm,
  vecSwapEnds: vecSwapEnds,
  vecBeginAt: vecBeginAt,
  vecEndAt: vecEndAt,
  vecTr: vecTr,
  vecTrDir: vecTrDir,
  bndFromPoints: bndFromPoints,
  bndFromVectors: bndFromVectors,
  bndAddPoint: bndAddPoint,
  bndAddPoints: bndAddPoints,
  bndLeftBottom: bndLeftBottom,
  bndLeftTop: bndLeftTop,
  bndRightBottom: bndRightBottom,
  bndRightTop: bndRightTop,
  bndAddMargin: bndAddMargin,
  bndAddMarginPct: bndAddMarginPct,
  bndMerge: bndMerge,
  bndMergeAll: bndMergeAll,
  bndMinX: bndMinX,
  bndMinY: bndMinY,
  bndMaxX: bndMaxX,
  bndMaxY: bndMaxY,
  bndIncludes: bndIncludes,
  bndWidth: bndWidth,
  bndHeight: bndHeight
};

var ey$1 = vecRev(ey);

function deg$1(d) {
  return deg(- d);
}

function rad$1(r) {
  return - r;
}

function toDeg$1(a) {
  return - toDeg(a);
}

function toRad$1(a) {
  return - a;
}

function bndAddMargin$1(b, all, left, right, top, bottom) {
  return bndAddMargin(b, all, left, right, bottom, top);
}

function bndAddMarginPct$1(b, all, left, right, top, bottom) {
  return bndAddMarginPct(b, all, left, right, bottom, top);
}

var Svg2D = {
  ex: ex,
  ey: ey$1,
  deg: deg$1,
  rad: rad$1,
  toDeg: toDeg$1,
  toRad: toRad$1,
  pntX: pntX,
  pntY: pntY,
  pntLen: pntLen,
  pntSub: pntSub,
  pntAdd: pntAdd,
  pntTr: pntTr,
  pntTrDir: pntTrDir,
  pntMul: pntMul,
  pntDiv: pntDiv,
  pntVec: pntVec,
  pntRot: pntRot,
  vecBegin: vecBegin,
  vecEnd: vecEnd,
  vecLen: vecLen,
  vecRev: vecRev,
  vecMul: vecMul,
  vecMulVec: vecMulVec,
  vecDiv: vecDiv,
  vecAdd: vecAdd,
  vecRot: vecRot,
  vecNorm: vecNorm,
  vecSwapEnds: vecSwapEnds,
  vecBeginAt: vecBeginAt,
  vecEndAt: vecEndAt,
  vecTr: vecTr,
  vecTrDir: vecTrDir,
  bndFromPoints: bndFromPoints,
  bndFromVectors: bndFromVectors,
  bndAddPoint: bndAddPoint,
  bndAddPoints: bndAddPoints,
  bndLeftBottom: bndLeftTop,
  bndLeftTop: bndLeftBottom,
  bndRightBottom: bndRightTop,
  bndRightTop: bndRightBottom,
  bndAddMargin: bndAddMargin$1,
  bndAddMarginPct: bndAddMarginPct$1,
  bndMerge: bndMerge,
  bndMergeAll: bndMergeAll,
  bndMinX: bndMinX,
  bndMinY: bndMinY,
  bndMaxX: bndMaxX,
  bndMaxY: bndMaxY,
  bndIncludes: bndIncludes,
  bndWidth: bndWidth,
  bndHeight: bndHeight
};

exports.Std2D = Std2D;
exports.Svg2D = Svg2D;
/* ey Not a pure module */
